<template>
    <div id="removeclass">
       <app-modal
        :modal-id="modalId"
        modal-alignment="top"
        modal-size="fullscreen"
        @close-modal="closeModal"
      >
        <template slot="header">
          <h5 v-if="isJobTemplate" class="modal-title">{{ $t("job_template") }}</h5>
          <button
            type="button"
            class="close outline-none"
            data-dismiss="modal"
            @click="closeModal"
          >
            <span>
              <app-icon :name="'x'"></app-icon>
            </span>
          </button>
        </template>
        <template slot="body">
            <job-create v-if="!isJobTemplate" :customerCompanyId="companyId" :refresh="back" :isTemplateJob="true" :isHideActions="true"></job-create>
            <job-template-list v-if="isJobTemplate" :company_id="companyId"></job-template-list>
        </template>
        <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="closeModal"
            >
                {{ $t("close") }}
            </button>
        </template>
      </app-modal>
    </div>
     
    </template>
    
    <script>
    import { FormMixin } from "../../../../core/mixins/form/FormMixin";
    import { ModalMixin } from "../../../../app/Mixins/ModalMixin";    

    export default {
      name: "JobCreateModal",
      mixins: [FormMixin, ModalMixin],
      props:{
        companyId: Number,
        isJobTemplate: Boolean,
      },
      data() {
        return {
            modalId: "job-create-modal",
        };
      },
      methods: {
        back(value) {
            this.closeModal();
        }
      },
      mounted() {
      },
    };
    </script>
    